import { render, staticRenderFns } from "./bh-flow-droppable.vue?vue&type=template&id=02871f5a&scoped=true&lang=pug"
import script from "./bh-flow-droppable.vue?vue&type=script&lang=ts"
export * from "./bh-flow-droppable.vue?vue&type=script&lang=ts"
import style0 from "./bh-flow-droppable.vue?vue&type=style&index=0&id=02871f5a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02871f5a",
  null
  
)

export default component.exports